import { createApp } from "vue";
import MatestackUiVueJs from "matestack-ui-vuejs";
import "daisy_stack/matestack_patches";
import adminToast from "../matestack/web/components/admin_toast";
import askAnswer from "../matestack/web/components/ask_answer";
import copyButton from "../matestack/web/components/copy_button";
import readingAids from "../matestack/web/components/reading_aids";
import themePicker from "../matestack/web/components/theme_picker";

const appInstance = createApp({});
appInstance.component("admin-toast", adminToast);
appInstance.component("ask-answer", askAnswer);
appInstance.component("copy-button", copyButton);
appInstance.component("reading-aids", readingAids);
appInstance.component("theme-picker", themePicker);

// Matestack transitions replace only the page, so the <title> would keep the
// first page's name. Every page (Web::Page) carries its full title in a
// hidden [data-page-title] element; copy it across once the new page is in.
MatestackUiVueJs.eventHub.$on("page_loaded", () => {
  requestAnimationFrame(() => {
    const marker = document.querySelector("#matestack-ui [data-page-title]");
    if (marker && marker.textContent) document.title = marker.textContent;
  });
});

document.addEventListener("DOMContentLoaded", () => {
  MatestackUiVueJs.mount(appInstance);
});
